


















import { Component, Vue } from 'vue-property-decorator'
import ProfilMenu from '@/components/ProfilMenu.vue'

@Component({
    components: {
        ProfilMenu,
    },
})
export default class IndexFunnel extends Vue {}
